export const STATIC_ROUTE_LABELS: Record<string, string> = {
  events: "Афиша",
  services: "Услуги",
  documents: "Документы",
  tickets: "Билеты и Ски-пассы",
  "cultural-objects": "Культурные объекты",
  rental: "Прокат и ремонт",
  "web-cams": "Веб-камеры",
  map: "Карта трасс",
  assistant: "AI помощник",
  equipments: "Прокат",
  ecotrap: "Экотропы",
  excursions: "Экскурсии",
  trails: "трассы и канатные дороги",
  accommodations: "Где остановиться",
  shop: "Магазин",
  "cafes-restaurants": "Кафе и рестораны",
  blog: "Блог",
  news: "Новости",
};

export const STATIC_ROUTE_HREFS: Record<string, string> = {
  events: "/events",
  services: "/services",
  documents: "/documents",
  tickets: "/tickets",
  "cultural-objects": "/cultural-objects",
  rental: "/rental",
  "web-cams": "/web-cams",
  map: "/map",
  ecotrap: "/ecotrails",
  excursions: "/excursions",
  assistant: "/assistant",
  equipments: "/equipments",
  trails: "/trails",
  accommodations: "/accommodations",
  shop: "/shop",
  "cafes-restaurants": "/cafes-restaurants",
  blog: "/blog",
  news: "/news",
};

export const TRANSLATE_KEYS: Record<string, string> = {
  accommodations: "Отель",
  ecotrap: "Экотропа",
  excursions: "Экскурсия",
  tickets: "Билет",
  cafes: "Кафе и рестораны",
  "cultural-objects": "Культурный объект",
  events: "Событие",
};
